// this file added by Bearer Web Developer
import React from "react";
import styles from './endStep.module.scss';
import { Button } from "@mui/material";
import { useAppState } from "../../../states/app-state";
import { useThemeMode } from "../../../states/contexts/theme";

const EndStep: React.FC = () => {

    const appState = useAppState();
    const { createAccount, accountVerification } = appState;
    const handleClose = () => {
        if (createAccount?.complete_registeration) accountVerification?.setOpen(true);
        createAccount?.setOpen(false);
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer

    return (
        <div className={styles.end_step} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */} 
            <div className={styles.header}>
                <h5>Welcome to Bearer!</h5>
                <div><Button className={styles.cancel} onClick={handleClose}><img src="/cancel.png" alt="X" /></Button></div>
            </div>
            <div className={styles.content}>
                <p>
                    Ready to simplify your deliveries with us?
                    <br />
                    Simply choose:
                    <br />
                    + Pickup Address
                    <br />
                    + Drop-off Address
                    <br />
                    + Parcel type
                    <br />
                    + Preferred delivery method
                    <br /><br />
                    Let’s get started!
                </p>
                <img src="/four-choices.webp" alt="" width={189} height={221} />
            </div>

            <div className={''}>
                <Button className={styles.submit} onClick={handleClose}>OK</Button>
            </div>
        </div>
    )
}
export default EndStep;